import React from 'react';
import { format } from 'date-fns';

interface INullableFormattedDateProps {
    value: Date | undefined;
}

export default function NullableFormattedDate(props: INullableFormattedDateProps): JSX.Element {
    const { value } = props;
    let utc_val;
    if(value != null) {
        try {
            utc_val = Date.UTC(value?.getUTCFullYear(), value?.getUTCMonth(), value?.getUTCDate());
        }
        catch {
            const valueDate = new Date(value);
            utc_val = Date.UTC(valueDate?.getUTCFullYear(), valueDate?.getUTCMonth(), valueDate?.getUTCDate());
        }
    }

    return (
        <>
            {utc_val
                ? < span >{format(utc_val, 'dd/MM/yyyy')}</span>
                : ' - '
            }
        </>
    );

}
